import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService } from '../../../../../core/services/dialog/dialog.service';
import { DialogActionConfigI } from './interfaces/dialog-action-config.interface';

@Component({
  selector: 'app-dialog-action-buttons',
  imports: [TranslateModule],
  templateUrl: './dialog-action-buttons.component.html',
  styleUrl: './dialog-action-buttons.component.scss',
})
export class DialogActionButtonsComponent {
  constructor(private readonly dialogService: DialogService) {}
  config = input.required<DialogActionConfigI>();
  closeDialog() {
    this.dialogService.closeDialog();
  }
}
